import config from '../config';
import axios from 'axios';
import Cookies from 'js-cookie';

axios.defaults.withCredentials = false
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Methods'] = "*";
axios.defaults.headers.post['Access-Control-Max-Age'] = "1000";
axios.defaults.headers.post['Access-Control-Allow-Headers'] = "x-requested-with, Content-Type, origin, authorization, accept, client-security-token";

export const post = async (url, body, params = {}, auth = {}) => {

  const filledUrl = replaceParams(url, params);

  const options = {
    headers: {
      Authorization: 'Bearer ' + getToken()
    }
  };

  if (auth.username || auth.password) {
    options.auth = auth;
  }

  return await axios.post(config.apiBaseUrl + filledUrl, body, options);
}

export const put = async (url, body, params = {}, auth = {}) => {
  const filledUrl = replaceParams(url, params);

  const options = {
    headers: {
      Authorization: 'Bearer ' + getToken()
    }
  };

  if (auth.password) {
    options.auth = auth;
  }

  return await axios.put(config.apiBaseUrl + filledUrl, body, options);
}

export const get = async (url, params = {}) => {

  const filledUrl = replaceParams(url, params);

  return await axios.get(config.apiBaseUrl + filledUrl, {
    headers: {
      Authorization: 'Bearer ' + getToken()
    },
  });
}

export const patch = async (url, body, params = {}, auth = {}) => {

  const filledUrl = replaceParams(url, params);

  return await axios.patch(config.apiBaseUrl + filledUrl, body, {
    headers: {
      Authorization: 'Bearer ' + getToken()
    }
  });
}


export const deleteRequest = async (url, params = {}, data = {}) => {
  const filledUrl = replaceParams(url, params);

  return await axios.delete(config.apiBaseUrl + filledUrl, {
    headers: {
      Authorization: 'Bearer ' + getToken()
    },
    data
  });
}

const getToken = () => {
  return JSON.parse(Cookies.get('authenticatedUser') || '{}')?.token || null;
}

function replaceParams(url, params) {
  let result = url

  Object.keys(params).forEach(key => {
    result = result.replace(`{${key}}`, params[key])
  })

  return result;
}

